module.exports = __webpack_public_path__ + "static/media/riverfolk2.51b76db5.jpg";